"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newAttributeFilterHandler = void 0;
var internal_1 = require("./internal");
/**
 * @public
 */
function newAttributeFilterHandler(backend, workspace, attributeFilter, options) {
    if (options === void 0) { options = { selectionMode: "multi" }; }
    var selectionMode = options.selectionMode, hiddenElements = options.hiddenElements, staticElements = options.staticElements;
    if (selectionMode === "multi") {
        return new internal_1.MultiSelectAttributeFilterHandler({
            backend: backend,
            workspace: workspace,
            attributeFilter: attributeFilter,
            hiddenElements: hiddenElements,
            staticElements: staticElements,
        });
    }
    return new internal_1.SingleSelectAttributeFilterHandler({
        backend: backend,
        workspace: workspace,
        attributeFilter: attributeFilter,
        hiddenElements: hiddenElements,
        staticElements: staticElements,
    });
}
exports.newAttributeFilterHandler = newAttributeFilterHandler;
//# sourceMappingURL=factory.js.map